import auth from './auth';
import system from './system';

// react-combine-reducers library асуудал — стандарт Redux-ийн combineReducers
// логиктой нэвтрэн бичсэн өөрийн хувилбар.
// Sub-reducer бүр шинэ reference буцаавал combined state-н шинэ reference үүсгэнэ.
const combineReducers = (reducerMap) => {
    const initialState = {};
    const reducerFns = {};

    Object.keys(reducerMap).forEach((key) => {
        const [reducerFn, slice] = reducerMap[key];
        initialState[key] = slice;
        reducerFns[key] = reducerFn;
    });

    const combinedReducer = (state, action) => {
        let hasChanged = false;
        const nextState = {};
        Object.keys(reducerFns).forEach((key) => {
            const previousSlice = state[key];
            const nextSlice = reducerFns[key](previousSlice, action);
            nextState[key] = nextSlice;
            if (nextSlice !== previousSlice) hasChanged = true;
        });
        return hasChanged ? nextState : state;
    };

    return [combinedReducer, initialState];
};

const [reducer, initialState] = combineReducers({
    auth,
    system,
});

export { reducer, initialState };